module.exports = __webpack_public_path__ + "img/credential-logo-niice.d36b85c3fe0db35d3c62c91edcb05c07.svg";